import { SearchPage } from 'modules/search-page/desktop';

export default SearchPage;
